import { render } from "./AudioLibraryShell.vue?vue&type=template&id=4e0784db&scoped=true"
import script from "./AudioLibraryShell.vue?vue&type=script&lang=js"
export * from "./AudioLibraryShell.vue?vue&type=script&lang=js"

import "./AudioLibraryShell.vue?vue&type=style&index=0&id=4e0784db&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0784db"]])

export default __exports__